exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Yantramanav:100);", ""]);

// module
exports.push([module.id, "body[data-v-d2c07bc6]{background-color:#eee;font-family:Montserrat,sans-serif;display:grid;grid-template-rows:auto;justify-items:center;padding-top:50px}body[data-v-d2c07bc6],html[data-v-d2c07bc6]{margin:0;height:100%}h1[data-v-d2c07bc6]{padding-left:30%;margin-top:auto;font-family:Yantramanav,sans-serif;font-size:100%;font-weight:2 0;color:#e1efe9;text-align:center}#app[data-v-d2c07bc6]{width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d2c07bc6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 17
// module chunks = 0